/** Query construction for browsers and native mini programs, without DOM globals. */
function decode(value: string): string {
  try { return decodeURIComponent(value.replace(/\+/g, ' ')) } catch { return value }
}

export function withQueryParams(endpoint: string, updates: Record<string, string | number | undefined>): string {
  const hashAt = endpoint.indexOf('#')
  const hash = hashAt < 0 ? '' : endpoint.slice(hashAt)
  const path = hashAt < 0 ? endpoint : endpoint.slice(0, hashAt)
  const at = path.indexOf('?')
  const pathname = at < 0 ? path : path.slice(0, at)
  const entries = (at < 0 ? '' : path.slice(at + 1)).split('&').filter(Boolean).map(part => {
    const equals = part.indexOf('=')
    return [decode(equals < 0 ? part : part.slice(0, equals)), decode(equals < 0 ? '' : part.slice(equals + 1))]
  }).filter(([key]) => !Object.prototype.hasOwnProperty.call(updates, key))
  for (const [key, value] of Object.entries(updates)) if (value !== undefined) entries.push([key, String(value)])
  const query = entries.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&')
  return pathname + (query ? '?' + query : '') + hash
}
